import type { FamilyOverview } from '../../api/models';

/** Mirrors android/…/Screens/Overview/OverviewState.kt. */
export type OverviewState = {
  isLoading: boolean;
  overview: FamilyOverview | null;
  error: string | null;
  /** Parent mode only — §4 puts the id in the parent column, never a child's (R0118). */
  errorCorrelationId: string | null;
};

/**
 * No children yet, and nothing wrong.
 *
 * Every destination is reachable from a cold start with no data, so its empty state is part of the
 * specification rather than a later detail — `13-Changing-This-System.md` §7.4.
 */
export const isEmpty = (state: OverviewState): boolean =>
  !state.isLoading && state.error === null && state.overview !== null && state.overview.children.length === 0;
